import { HtmlContentProperty } from '../../../interfaces/html-content-property';
import { HtmlContentSection } from '../html-content-section';
import { HtmlContentTarget } from '../../../interfaces/html-content-target';

// text length finds the total text length if this element is added to the current section
export const textLength: HtmlContentProperty = {
  name: 'textLength',
  value: (target: HtmlContentTarget, style: CSSStyleDeclaration, section: HtmlContentSection) =>
    section.getText().join().length + (target.node.textContent != null ? target.node.textContent.trim().length : 0)
};
